import { fmtDateTimeIST } from '@/lib/format';
import { toast } from 'sonner';

/** Shown when the user lacks edit permission (or the API returns 403). */
export const UNAUTHORIZED_EDIT_MSG = 'You are not authorized to edit this section.';

export function isUnauthorizedError(err) {
  if (err?.response?.status === 403) return true;
  const detail = err?.response?.data?.detail;
  return Boolean(detail && typeof detail === 'object' && detail.error === 'unauthorized');
}

export function toastMutationError(err, fallback) {
  if (isUnauthorizedError(err)) {
    toast.warning(UNAUTHORIZED_EDIT_MSG);
    return;
  }
  const detail = err?.response?.data?.detail || err?.message || fallback;
  toast.error(typeof detail === 'string' ? detail : fallback);
}

export function ftime(iso) {
  if (!iso) return '—';
  try { return fmtDateTimeIST(iso, { dateStyle: 'medium', timeStyle: 'short' }, iso); }
  catch { return iso; }
}
